function CustomLoader() {
  return (
    <div className="w-15 h-15 absolute top-1/2 left-[44%] sm:left-[50%] ">
      <div className="dot absolute inset-0 flex justify-center">
        <div className="w-2 h-2 rounded-full bg-sky-500"></div>
      </div>
      <div className="dot absolute inset-0 flex justify-center">
        <div className="w-2 h-2 rounded-full bg-sky-500"></div>
      </div>
      <div className="dot absolute inset-0 flex justify-center">
        <div className="w-2 h-2 rounded-full bg-sky-500"></div>
      </div>
      <div className="dot absolute inset-0 flex justify-center">
        <div className="w-2 h-2 rounded-full bg-sky-500"></div>
      </div>
      <div className="dot absolute inset-0 flex justify-center">
        <div className="w-2 h-2 rounded-full bg-sky-500"></div>
      </div>
    </div>
  )
}

export default CustomLoader
